import { useState as u, useCallback as x } from "../../../../external/preact/hooks/dist/hooks.module.js";
const W = () => {
  const [s, r] = u([]), n = x((a) => {
    r(
      (o) => a.every((t) => !t) ? a : a.map((t, c) => {
        const e = o[c];
        return !e || t > e ? t : e;
      })
    );
  }, []);
  return [s, n];
};
export {
  W as useMaxWidthsState
};
